import { useCallback } from 'react';
import {
  updateMouseflowTrackingURLContext,
  useUiValue,
} from 'stores/uiContext';

const useMouseflowTracking = () => {
  const [{ mouseflowTrackingURL }, dispatch] = useUiValue();

  const updateMouseflowTrackingURL = useCallback(
    (url) => {
      dispatch(updateMouseflowTrackingURLContext(url));
    },
    [dispatch],
  );

  return {
    mouseflowTrackingURL,
    updateMouseflowTrackingURL,
  };
};
export default useMouseflowTracking;
